import { render, staticRenderFns } from "./twitterXIcon.vue?vue&type=template&id=aa7d6662"
import script from "./twitterXIcon.vue?vue&type=script&lang=js"
export * from "./twitterXIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports